<template>
	<el-dialog class="reportDialog" :visible="show" append-to-body @close="handleClose" @open="getFanSi">
		<div slot="title">
			<div class="dislogTitle">
				群成员
			</div>
		</div>
		<div class="dislogConent">
			<div class="fanList">
				<div class="fans" v-for="(item,index) in fanSiData" :key="index" @click="item.check = !item.check">
					<div class="left">
						<img class="avatar" :src="item.user.avatar" v-if="item.user && item.user.avatar" />
						<img class="avatar" src="../assets/defaultAvatar.png" v-else />
						{{item.user && item.user.user_nickname ? item.user.user_nickname : ''}}
					</div>
					<div v-if="showMenu">
						<div class="delete" v-if="userId != item.user_id" @click="deleteFans(item)">移除</div>
					</div>
				</div>
			</div>
		</div>
		<div slot="footer">
			<div class="menuBox" v-if="showMenu">
				<el-button class="submit" type="primary" size="medium" @click="submitForm()">添加成员</el-button>
				<el-button class="stepNext" type="primary" size="medium" @click="nextStep">解散群组</el-button>
			</div>
		</div>
	</el-dialog>
</template>

<script>
	export default {
		props: {
			show: {
				type: Boolean,
				default: false,
			},
			gid: {
				type: [String, Number],
				default: '',
			},
			data: {
				type: Object,
				default: () => {},
			},
			showMenu: {
				type: Boolean,
				default: true,
			},
		},
		data() {
			return {
				userId: localStorage.getItem('userId'),
				isClose: false,
				fanSiData: [],
			}
		},
		methods: {
			handleClose() {
				this.$emit('close', this.isClose)
			},
			getFanSi() {
				this.$api.post('/Liaotian/group_user', {
					gid: this.gid
				}).then(res => {
					if (res.code == 1) {
						this.fanSiData = res.data
					}
				}).catch(err => {
					console.log(err);
				})
			},
			deleteFans(item) {
				this.$api.post('/Liaotian/del_lt', {
					gid: item.gid,
					type: 2,
					user_id: item.user_id
				}).then(res => {
					if (res.code == 1) {
						this.$message.success(res.msg)
						this.getFanSi()
					} else {
						this.$message.error(res.msg)
					}
				}).catch(err => {
					console.log(err);
				})
			},
			nextStep() {
				this.$emit('nextStep')
				this.handleClose()
			},
			submitForm() {
				this.$emit('addFans')
			}
		}
	}
</script>

<style scoped lang="scss">
	.reportDialog {

		::v-deep .el-dialog {
			width: 4.58rem;
			border-radius: .12rem;

			&__headerbtn {
				top: .24rem;
				right: .24rem;
				font-size: .16rem;
			}

			&__header {
				padding: .24rem .24rem;

				.dislogTitle {
					font-weight: 500;
					font-size: .18rem;
					color: #252525;
				}
			}

			&__body {
				padding: 0 .24rem;


				.fanList {
					height: 5rem;
					overflow-y: auto;

					.fans {
						height: .72rem;
						display: flex;
						align-items: center;
						justify-content: space-between;
						border-bottom: .01rem solid #CCCCCC;
						cursor: pointer;

						.left {
							display: flex;
							align-items: center;
							font-size: .16rem;
							color: #161616;
							line-height: .24rem;

							.avatar {
								margin-right: .12rem;
								width: .4rem;
								height: .4rem;
								object-fit: cover;
								border-radius: 50%;
							}
						}

						.delete {
							font-size: 400;
							font-size: .14rem;
							color: #E29358;
						}
					}
				}

				.el-form {

					&-item:nth-child(4),
					&-item:nth-child(5) {
						align-items: flex-start;

						.el-form-item__label {
							margin-top: .16rem;
						}
					}

					&-item {
						display: flex;
						align-items: center;
						margin-bottom: .24rem;

						&__label {
							width: 1.1rem;
							font-size: .14rem;
							color: #252525;
							line-height: .2rem;
						}

						&__error {
							font-size: .12rem;
							padding-top: .04rem;
						}

						&__content {

							.el-textarea {
								&__inner {
									width: 4.1rem;
									padding: .08rem .16rem;
									font-weight: 400;
									font-size: .14rem;
									color: #252525;
									border: .01rem solid #EFD8B8;
								}
							}

							.el-input {

								&__inner {
									width: 4.1rem;
									height: .52rem;
									font-weight: 400;
									font-size: .14rem;
									color: #252525;
									line-height: .52rem;
									border: .01rem solid #EFD8B8;
								}

								&__icon {
									font-size: .14rem;
								}
							}
						}
					}
				}
			}

			&__footer {
				padding: .08rem .24rem .24rem;

				.menuBox {
					display: flex;
					align-items: center;
					justify-content: center;

					.stepNext {
						margin: .32rem .16rem 0;
						width: 1.3rem;
						height: .36rem;
						background: #FFFFFF;
						border-radius: .04rem;
						padding: 0 0;
						font-weight: 400;
						font-size: .14rem;
						color: #E29358;
						text-align: center;
						line-height: .36rem;
						border: none;
						cursor: pointer;
						border: .01rem solid #E29358;
					}

					.submit {
						margin: .32rem .16rem 0;
						width: 1.3rem;
						height: .36rem;
						background: #E29358;
						border-radius: .04rem;
						padding: 0 0;
						font-weight: 400;
						font-size: .14rem;
						color: #252525;
						text-align: center;
						line-height: .36rem;
						border: none;
						cursor: pointer;
					}
				}
			}
		}
	}
</style>